import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconAlignRight$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconAlignRight extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '3f506ba147899a48516b595e9a1a1179873a6dbe', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'f628d0ae34dd366f82a98c2975eaabcf9cb9e781', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'eefc05e2b464f233c8e056eae2b9eae0bc4ffa0a', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3 5.5a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-.5.5h-15A.5.5 0 0 1 3 6zm4 5.25a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5zm5.5 4.75a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V16a.5.5 0 0 0-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-align-right", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-align-right"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-align-right":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconAlignRight$1);
            }
            break;
    } });
}

const CosmosIconAlignRight = CosmosIconAlignRight$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconAlignRight, defineCustomElement };
